












import { Component, Vue } from 'vue-property-decorator';
import SessionList from './SessionList.vue';
import BoardList from './BoardList.vue';
import { Getter } from 'vuex-class';
import { BoardGettersReturns } from '@/store/types/board';

@Component({
  components: {
    BoardList,
    SessionList,
  },
})
export default class MyBoards extends Vue {
  @Getter boardFilter!: BoardGettersReturns['boardFilter'];

  selectedBoard = null;
}
